import Vform from "@/vuetify_custom/v-form";
import { getAmsPlatformListApi } from "@/views/business/service.js";
import {
  account_status,
  account_types,
} from "@/views/fin/account_management/fields.js";
import { VBtn } from "vuetify/lib";
import upload_mixin from "@/views/fin/account_management/upload_mixin.js";
export default {
  mixins: [upload_mixin],
  props: {
    value: {
      type: Object,
    },
    showBatch: {
      type: Boolean,
      default: () => false,
    },
    isFin: {
      type: Boolean,
    },
  },
  data() {
    return {
      platform_list: [],
      params: this.vlaue,
      need_upload_id: false,
    };
  },
  computed: {
    search_fields() {
      return [
        {
          label: "账号类型",
          type: "select_field_v1",
          key: "account_type",
          cols: 3,
          clearable: true,
          items: account_types,
          change: this.proxyGetData,
          show: true,
        },
        {
          label: "所属平台",
          key: "platform_id",
          // initList: this.defaultApply,
          type: "autocompletes",
          "item-value": "id",
          "item-text": "name",
          clearable: true,
          items: this.platform_list,
          cols: 3,
          change: this.proxyGetData,
          show: true,
        },
        {
          label: "项目组",
          key: "team_id",
          type: "team_select",
          cols: 3,
          clearable: true,
          change: this.proxyGetData,
          show: this.isFin,
        },
        {
          label: "负责人",
          key: "customer_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "account",
          api: this.$util.api.customer_select_search,
          init_list: [], // this.apply_user_list,
          cols: 2,
          out_params: {
            formal: true,
          },

          handle_data: ({ customers }) => {
            return customers;
          },
          change: this.proxyGetData,
          show: true,
        },
        {
          label: "账户状态",
          type: "select_field_v1",
          key: "account_status",
          cols: 3,
          clearable: true,
          items: account_status,
          change: this.proxyGetData,
          show: true,
        },
        {
          label: "月份",
          type: "month_picker_v1",
          key: "year_month",
          cols: 3,
          show: true,
          clearable: true,
          change: this.proxyGetData,
        },
        {
          label: "校验状态",
          type: "select_field",
          key: "verified",
          cols: 3,
          items: [
            { label: "已校验", value: true },
            { label: "未校验", value: false },
          ],
          "item-text": "label",
          "item-value": "value",
          show: this.params && this.params.year_month,
          clearable: true,
          change: this.proxyGetData,
        },
        {
          key: "search",
          cols: 3,
          clearable: true,
          "append-icon": "mdi-magnify",
          "single-line": true,
          "click:clear": () => this.proxyGetData(),
          "click:append": () => this.proxyGetData(),
          "keydown.enter": () => this.proxyGetData(),
          show: true,
        },
        {
          key: "handle",
          cols: 3,
          show: true,
        },
      ].filter((i) => i.show);
    },
  },
  watch: {
    params(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.params = val;
    },
  },
  created() {
    this.initList();
  },
  methods: {
    initList() {
      getAmsPlatformListApi().then((data) => {
        this.platform_list = data;
      });
    },
    proxyGetData() {
      this.$nextTick(() => this.$emit("asyncGet"));
    },
  },
  render() {
    return (
      <div>
        <Vform
          fields={this.search_fields}
          v-model={this.params}
          scopedSlots={{
            handle: () => {
              return (
                <div>
                  {this.showBatch && (
                    <VBtn
                      color="primary"
                      loading={this.uploading}
                      on={{
                        click: this.upload,
                      }}
                    >
                      批量导入
                    </VBtn>
                  )}
                </div>
              );
            },
          }}
        />
        <div ref="contain" style="display:none" />
      </div>
    );
  },
};
